// src/components/uiElements/UIComponents/bento-grid/bento-grid.jsx
import { Link } from "react-router-dom";
import "./bento.css";
import { PButtonTile } from "@porsche-design-system/components-react";
import BlurFade from "@/components/magicui/blur-fade";
import { scrollToTop } from "MainApp/assets/visual/styles/globalStyles/globalJsxStyles";
import { useMemo, useState } from "react";

const BentoCard = ({
  title,
  images,
  Icon,
  description,
  price,
  duration,
  id,
  tourState,
  index,
  onImagesLoad,
  imageLoaded,
  callOnExit,
  isIframe,
  slug, // ← SIEMPRE canónico (de tours.slug)
}) => {
  const safeSlug = useMemo(() => encodeURIComponent(slug ?? ""), [slug]);
  const routePath = useMemo(() => `/tour/details/${safeSlug}`, [safeSlug]);

  const [finalUrl, setFinalUrl] = useState("");

  const callIframe = () => {
    const queryParams = new URLSearchParams({ ...tourState, slug }).toString();
    const urlWithParams = queryParams ? `${routePath}?${queryParams}` : routePath;
    const computedUrl = `https://prod.thestablegame.com${urlWithParams}`;
    setFinalUrl(computedUrl);
    window.parent.postMessage({ action: "showOverlayIframe", payload: computedUrl }, "*");
  };

  return (
    <>
      {imageLoaded && (
        <Link
          to={isIframe ? "" : routePath}
          state={{ ...tourState, slug }} // envía el slug canónico en state
          onClick={isIframe ? (e) => { e.preventDefault(); callIframe(); } : callOnExit}
        >
          <BlurFade delay={0.25 + index * 0.05} inView>
            <PButtonTile
              label="Buttons"
              description={title}
              compact={true}
              onClick={scrollToTop}
            >
              <img src={images} alt={title || "Tour"} />
            </PButtonTile>
          </BlurFade>
        </Link>
      )}

      <img src={images} onLoad={onImagesLoad} style={{ display: "none" }} alt="" />
    </>
  );
};

export { BentoCard };
